var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 316 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1750",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Message 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13434",
    d: "M16.979 5.589A5.155 5.155 0 0 0 16.389 4a30.268 30.268 0 0 1-2.8 2.486A7.59 7.59 0 0 1 9.5 8.364a7.59 7.59 0 0 1-4.087-1.878A30.276 30.276 0 0 1 2.611 4a5.153 5.153 0 0 0-.59 1.589l-.021.1a29.228 29.228 0 0 0 2.419 2.1A9.093 9.093 0 0 0 9.5 10a9.093 9.093 0 0 0 5.081-2.214A29.236 29.236 0 0 0 17 5.689z",
    transform: "translate(-.5 -.571)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13435",
    d: "M0 9c0 7.411 1.588 9 9 9s9-1.589 9-9-1.589-9-9-9-9 1.589-9 9zm9 7.5a20.175 20.175 0 0 1-4.208-.328 3.914 3.914 0 0 1-2.011-.953 3.914 3.914 0 0 1-.953-2.011A20.18 20.18 0 0 1 1.5 9a20.179 20.179 0 0 1 .328-4.208 3.914 3.914 0 0 1 .953-2.011 3.914 3.914 0 0 1 2.011-.953A20.179 20.179 0 0 1 9 1.5a20.179 20.179 0 0 1 4.208.328 3.914 3.914 0 0 1 2.011.953 3.914 3.914 0 0 1 .953 2.011A20.177 20.177 0 0 1 16.5 9a20.178 20.178 0 0 1-.328 4.208 3.914 3.914 0 0 1-.953 2.011 3.914 3.914 0 0 1-2.011.953A20.175 20.175 0 0 1 9 16.5z",
    style: {
      fill: "#abafd1",
      fillRule: "evenodd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.dae01746b1e89c6405b6c636615c4ffe.svg";
export { ForwardRef as ReactComponent };